<template>
  <div class="orgs-list">
    <app-loading :visible="loading" />
    <transition-group class="md-title nav" tag="div" :name="navAnimationName">
      <div
        v-for="org in nav" :key="org.id"
        class="nav-content">
          <span></span><router-link :to="{ name: 'OrganizationListPage', query: getFormQueryParams(org.id) }">{{ org.shortName }}</router-link>
      </div>
    </transition-group>
    <div class="toolbar">
      <md-field md-clearable class="list-search-field" ref="searchField"  v-on:md-clear="onSearchClear">
        <md-input :placeholder="translate('placeholder')"
          v-model="searchTerm"
          type="text"
          class="input-content"
          v-on:keyup.enter="searchOrganizations"></md-input>
      </md-field>
      <div class="button-add-wrp">
        <md-button class="md-icon-button md-raised md-primary search-placing" v-on:click="searchOrganizations">
          <md-icon>search</md-icon>
        </md-button>
        <md-button class="md-icon-button md-raised md-primary add-placing" v-on:click="goToAddForm" v-if="canAdd()">
          <md-icon>add</md-icon>
        </md-button>
      </div>
    </div>
    <md-table v-model="orgs" v-show="!loading">
      <md-table-empty-state
        :md-label="nothingWasFound">
      </md-table-empty-state>
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell :md-label="officialName">
          <router-link :to="{
            name: 'OrganizationListPage',
            query: { parent_id: item.id, broswernav: true }
          }">
          <span>{{ item.officialName }}</span>
          <!-- v-on:click="resetSearchTerm" -->
          </router-link>
        </md-table-cell>
        <md-table-cell :md-label="shortName">{{ item.shortName }}</md-table-cell>
        <md-table-cell>
          <md-button class="md-icon-button md-raised md-primary"
            :to="{ name: 'OrganizationFormEditPage', params: { orgId: item.id }, query: getFormQueryParams(item.id, false) }">
            <md-icon>create</md-icon>
          </md-button>
          <md-button class="md-icon-button md-raised md-primary"
            :to="{ name: 'MemberListPage', query: { party_organization_id: item.id } }">
            <md-icon>group</md-icon>
          </md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>
  </div>
</template>

<script>
import AppLoading from '@/components/ui/AppLoading.vue'
import HasLoading from '@/mixins/HasLoading.mixin'
import OrganizationService from '@/common/services/organization'
import HasListFilter from '@/mixins/HasListFilter.mixin'
import HttpClient from '@/common/http'
import Auth from '@//common/auth/index.js'
import debounce from 'debounce'

export default {
  name: 'OrganizationListComponent',
  components: {
    AppLoading
  },
  mixins: [
    HasLoading,
    HasListFilter
  ],
  data () {
    return {
      /** @type {Organization[]} */
      orgs: [],
      nav: [],
      canManage: Auth.CanManageOrgs()
      // nullQuery: { parent_id: this.$config.rootParentId }
    }
  },
  computed: {
    navAnimationName () {
      return (
        this.isCurrentParentIdInNav() ||
        !this.hasQueryParentId() ||
        this.getQueryParentId() === this.$config.rootParentId
      ) ? 'none' : 'nav-anim' // do not apply animation when we ascending to the top of hierarchy
    }
  },
  watch: {
    '$route.query.parent_id' () {
      if (this.$route.query.parent_id) {
        this.watchQuery()
      }
    },
    '$route.query.search_term' (val) {
      this.watchSearchTerm(val)
    },
    searchTerm (val, oldValue) {
      // if (val === '' && oldValue !== '' && this.appliedSearchTerm) {
      //   console.log('wst')
      //   this.commitSearchTerm(q => {
      //     if (!q.search_term) {
      //       q.parent_id = this.$config.rootParentId
      //     }
      //   })
      // }
    }
  },
  created () {
    this.watchSearchTerm = debounce(this.watchSearchTerm, 300)

    this.initTableLabels()

    this.initCancelTokens()

    const currentParentId = this.getQueryParentId()
    if (this.hasQueryParentId()) { // Loaded page with defined parent id
      this.restoreNav(currentParentId)
      this.readOrganizations()
    } else { // Loaded page with undefined parent id
      if (!this.hasQuerySearchTerm()) { // if there is no search term add root parent id
        this.navigateTo(currentParentId, true)
      } else {
        this.readOrganizations()
      }
    }
  },
  methods: {
    onSearchClear () {
      this.searchTerm = ''
      this.commitSearchTerm()
    },
    watchSearchTerm (val) {
      this.setQuerySearchTerm(val || '')
      // if (/* val && */! this.$route.query.parent_id) {
      this.watchQuery()
      // }
    },
    canAdd () {
      return this.canManage && !this.appliedSearchTerm
    },
    initTableLabels () {
      this.officialName = this.translate('officialName')
      this.shortName = this.translate('shortName')
      this.nothingWasFound = this.translate('nothingWasFound')
    },
    hasQueryParentId () {
      return this.$route.query.parent_id !== undefined
    },
    getQueryParentId (retNull = false) {
      return this.$route.query.parent_id || (retNull ? null : this.$config.rootParentId)
    },
    initCancelTokens () {
      this.cancelTokens = {
        all: null,
        single: null
      }
    },
    cancelRequest () {
      if (this.cancelTokens.all !== null) {
        this.cancelTokens.all.cancel()
        if (this.cancelTokens.single !== null) {
          this.cancelTokens.single.cancel()
        }
      }
    },
    resetSearchTerm () {
      this.nav = []
      // this.appliedSearchTerm = ''
      this.$refs.searchField.clearInput()
    },
    readOrganizations () {
      this.startAppLoading()

      this.cancelTokens.all = HttpClient.cancelToken.source()

      return OrganizationService.Select(
        this.getQueryParentId(),
        this.searchTerm,
        this.cancelTokens.all
      )
        .then(response => {
          this.cancelTokens.all = null
          this.orgs = response.data
        })
        .catch(error => this.$httpError.handle.call(this, error))
        .then(() => {
          // this.setQuerySearchTerm()
          // if (!this.$route.query.broswernav) {
          //   this.commitSearchTerm(q => {
          //     if (!q.search_term && !q.parent_id) {
          //       q.parent_id = this.$config.rootParentId
          //     }
          //   })
          // }

          this.finishAppLoading()
        })
    },
    searchOrganizations () {
      this.commitSearchTerm(q => {
        if (q.search_term) {
          delete q.parent_id
        }
      })
    },
    watchQuery () {
      this.cancelRequest('all')

      this.readOrganizations()
      // || this.hasQuerySearchTerm()
      if (this.isCurrentParentIdInNav()) {
        this.cleanUpNav()
      } else {
        this.nav = []
        this.restoreNav(this.getQueryParentId())
      }
    },
    navigateTo (parentId, replace = false) {
      const location = {
        name: this.$route.name,
        query: this.getFormQueryParams(parentId)
      }

      replace ? this.$router.replace(location) : this.$router.push(location)
    },
    restoreNavRecursive (orgId) {
      if (String(orgId) !== '0') {
        this.cancelTokens.single = HttpClient.cancelToken.source()

        OrganizationService.Get(orgId, this.cancelTokens.single)
          .then(response => {
            this.cancelTokens.single = null
            const organization = response.data
            this.nav.unshift(organization)
            this.restoreNavRecursive(organization.parentId)
          })
          .catch(error => this.$httpError.handle.call(this, error))
      }
    },
    restoreNav (startParentId) {
      this.restoreNavRecursive(startParentId)
    },
    /**
     * @param {Organization} organization
     */
    readChildren (organization) {
      if (!this.isAppLoading()) {
        this.nav.push(organization)
        this.navigateTo(organization.id)
      }
    },
    /**
     * @param {Organization} organization
     */
    getChildrenLink (item) {
      return this.$router
    },
    isLastNav (navIndex) {
      return navIndex === this.nav.length - 1
    },
    // returnBack (organization, organizationIndex) {
    //   if (!this.isLastNav(organizationIndex)) {
    //     this.nav.splice(organizationIndex + 1)
    //     this.navigateTo(organization.id)
    //   }
    // },
    getCurrentParentIdPosInNav () {
      const parentId = this.getQueryParentId()
      return this.nav.findIndex(navItem => {
        return navItem.id === parentId
      })
    },
    isCurrentParentIdInNav () {
      return this.getCurrentParentIdPosInNav() !== -1
    },
    cleanUpNav () {
      const parentIdPosInNav = this.getCurrentParentIdPosInNav()
      if (parentIdPosInNav >= 0 && parentIdPosInNav !== this.nav.length - 1) {
        this.nav.splice(parentIdPosInNav + 1)
      }
    },
    getFormQueryParams (parentId, withParentId = true) {
      const qp = {}

      if (withParentId) {
        qp.parent_id = parentId
      }

      if (this.appliedSearchTerm) {
        const searchTermKey = this.getQuerySearchTermKey()
        qp[searchTermKey] = this.appliedSearchTerm
      }

      return qp
    },
    goToAddForm () {
      this.$router.push({
        name: 'OrganizationFormAddPage',
        query: this.getFormQueryParams(this.getQueryParentId())
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-anim-leave-active {
  transition: opacity 2s;
}

.nav {
  display: flex;

  .nav-content {
    margin-left: 10px;
  }

  .nav-content:last-child a {
    text-decoration: none;
    color: inherit;
  }
  .nav-content:last-child a:hover {
    color: inherit;
  }
  .nav-content span:before {
    content: "/ ";
  }
  .nav-content:first-child span {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organizations/List.vue